<template lang="html">
  <div class="star-wrapper">
    <ul :class="size">
      <li
        v-for="(scoreClass, index) in scoreClassArr"
        :key="index"
        :class="{ active: scoreClass.isCur, half: scoreClass.isHalf }"
        @click="clickStar(index + 1)"
      >
        <i class="iconfont icon-xingxing icon-down"></i>
        <div class="icon-up-wrapper">
          <i
            class="iconfont icon-xingxing icon-up"
            :style="{ color: color }"
          ></i>
        </div>
      </li>
    </ul>
    <p v-if="levelName !== '' && needBracket" class="">({{ levelName }})</p>
    <p v-else>{{ levelName }}</p>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'small'
    },
    score: {
      // 评分
      type: [Number, String],
      default: 0
    },
    scoreNo: {
      // 星星数
      type: [Number, String],
      default: -1
    },
    canClick: {
      // 星星是否可点
      type: Boolean,
      default: false
    },
    levelName: {
      type: String,
      default: ''
    },
    // 星星亮的颜色
    color: {
      type: String,
      default: '#FFB320'
    },
    needBracket: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      scoreArr: [{}, {}, {}, {}, {}],
      avg: this.score
    }
  },
  watch: {
    score(val) {
      this.avg = val
    }
  },
  computed: {
    scoreClassArr() {
      if (this.scoreNo >= 0 && this.scoreNo !== -1) {
        this.avg = this.scoreNo * 2
      }
      if (this.avg > 10) {
        this.avg = 10
      } else if (this.avg <= 0) {
        this.avg = 0
      }
      const x = parseInt(this.avg / 2, 10)
      this.scoreArr.forEach(ele => {
        ele.isCur = false
        ele.isHalf = false
      })
      for (let i = 0; i < x; i += 1) {
        this.scoreArr[i].isCur = true
      }
      if (this.avg % 2 !== 0 && this.scoreArr[x]) {
        this.scoreArr[x].isHalf = true
      }
      return this.scoreArr
    }
  },
  methods: {
    clickStar(index) {
      if (this.canClick) {
        this.avg = index * 2
        this.$emit('clickStar', index * 2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin';

.star-wrapper {
  display: flex;
  align-items: center;

  ul {
    display: flex;
    // flex: 1;
    align-items: center;
  }
  > p {
    font-size: rem(22px);
    color: #999;
  }
  li {
    position: relative;
    margin-right: rem(15px);

    .icon-xingxing {
      color: #dfdfdf;
    }
    .icon-down {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      color: #dfdfdf;
    }
    .icon-up-wrapper {
      position: relative;
      width: 0;
      height: 100%;
      overflow: hidden;
    }
    .icon-up {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      color: #ff397e;
      z-index: 1;
    }
    &.active {
      .icon-up-wrapper {
        width: 100%;
      }
    }
    &.half {
      .icon-up-wrapper {
        width: 50%;
      }
    }
    &::last-child {
      margin-right: 0;
    }
  }
  .orange {
    .icon-up {
      color: #ffc600;
    }
  }
  .small {
    li {
      font-size: rem(16px);
      margin-right: rem(5px);
      width: rem(16px);
      height: rem(16px);
    }

    .icon-xingxing {
      font-size: rem(16px);
    }
  }
  .medium {
    li {
      font-size: 12px;
      margin-right: rem(5px);
      width: 12px;
      height: 12px;
    }

    .icon-xingxing {
      font-size: 12px;
    }
  }

  .big {
    li {
      margin-right: rem(10px);
      width: rem(30px);
      height: rem(30px);
    }

    .icon-xingxing {
      font-size: rem(30px);
    }
  }
  .bigger {
    li {
      width: rem(50px);
      height: rem(50px);
    }
    .icon-xingxing {
      font-size: rem(50px);
    }
  }

  .biggest {
    li {
      width: rem(60px);
      height: rem(60px);
    }
    .icon-xingxing {
      font-size: rem(60px);
    }
  }
}
</style>
